<template lang="pug">
button.btn.sidebarPersonalitation-btn.rounded-0(@click="toggleSidebar")
  i.fas.fa-bars.mr-2
  span {{ t('menu.user_subscription.menu') }}
</template>

<script>
import mixins from "common/mixins"

export default {
  mixins: [mixins.translate],
  name: "user-subscription-sidebar-toggle-vue",
  methods: {
    toggleSidebar() {
      window.dispatchEvent(new CustomEvent('toggle-sidebar'))
    }
  }
}
</script>